import { Grid, Typography } from "@mui/material";
import { Children, PropsWithChildren } from "react";

export interface PageHeaderProps {
  readonly headerText: string;
}

export default function PageHeader({ headerText, children }: PropsWithChildren<PageHeaderProps>) {
  return (
    <Grid container mb={3} py={1} alignItems="center">
      <Grid item xs={6}>
        <Typography variant="h4">{headerText}</Typography>
      </Grid>
      <Grid container item xs={6} columnSpacing={2} justifyContent="flex-end">
        {Children.map(children, (child) => child && <Grid item>{child}</Grid>)}
      </Grid>
    </Grid>
  );
}
